var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Select, Button, TextArea } from 'ui/styled';
import { CXoneAcdClient } from '@nice-devone/acd-sdk';
import { MediaType } from '@nice-devone/common-sdk';
import { Spin, message } from 'antd';
import { useNicService } from 'stores/nic/useNicService';
import { selectAgentSkills, useNicStore } from 'stores/nic/stores/nicStore';
import { useCallStore } from 'stores/nic/stores/callStore';
import { ChooseDispositionLabel, DispositionsMenu } from './styled';
var DispositionView = function (_a) {
    var skill = _a.skill, currentCall = _a.currentCall;
    var _b = useState(null), disposition = _b[0], setDisposition = _b[1];
    var _c = useState(''), dispositionNotes = _c[0], setDispositionNotes = _c[1];
    var _d = useState([]), availableDispositions = _d[0], setAvailableDispositions = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var changeAgentStatus = useNicService().changeAgentStatus;
    var agentSkills = useNicStore(selectAgentSkills);
    var lastCallSkill = useCallStore(function (state) { return state.lastCallSkill; });
    var lastCallContactID = useCallStore(function (state) { return state.lastCallContactID; });
    var getDispositions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var skillForDisposition, dispositions, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    skillForDisposition = lastCallSkill ||
                        (currentCall === null || currentCall === void 0 ? void 0 : currentCall.skill) ||
                        skill ||
                        ((_a = agentSkills.find(function (s) { return s.useACW; })) === null || _a === void 0 ? void 0 : _a.skillId);
                    if (!skillForDisposition)
                        return [2 /*return*/];
                    return [4 /*yield*/, CXoneAcdClient.instance.contactManager.getDispositions(String(skillForDisposition), MediaType.VOICE)
                        // Handle the response properly - it can be an array or an error
                    ];
                case 1:
                    dispositions = _b.sent();
                    // Handle the response properly - it can be an array or an error
                    if (Array.isArray(dispositions)) {
                        setAvailableDispositions(dispositions.map(function (item) { return ({
                            label: item.dispositionName,
                            value: item.dispositionId
                        }); }));
                    }
                    else {
                        console.error('Failed to get dispositions:', dispositions);
                        setAvailableDispositions([]);
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error('Failed to get dispositions:', error_1);
                    setAvailableDispositions([]);
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getDispositions();
    }, []);
    var saveDisposition = function () { return __awaiter(void 0, void 0, void 0, function () {
        var contactID, dispositionPayload, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contactID = (currentCall === null || currentCall === void 0 ? void 0 : currentCall.contactID) || lastCallContactID;
                    if (!contactID) {
                        return [2 /*return*/, message.error('Unable to save disposition: contact ID is missing')];
                    }
                    if (!availableDispositions.length) {
                        return [2 /*return*/, message.error('Unable to save disposition: no available disposition')];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    dispositionPayload = {
                        primaryDispositionId: disposition,
                        primaryDispositionNotes: dispositionNotes
                    };
                    return [4 /*yield*/, CXoneAcdClient.instance.contactManager.saveDisposition(contactID, dispositionPayload)];
                case 2:
                    _a.sent();
                    console.log('Disposition saved successfully');
                    useCallStore.getState().setLastCallSkill(null);
                    useCallStore.getState().setLastCallContactID(null);
                    useCallStore.getState().setLastCallRequireDisposition(false);
                    return [4 /*yield*/, changeAgentStatus('available')];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console.error('Failed to save disposition:', error_2);
                    message.error('Failed to save disposition');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { children: [_jsx(ChooseDispositionLabel, { children: "Choose Disposition" }), _jsx(Spin, { spinning: loading, children: _jsxs(DispositionsMenu, { children: [_jsx(Select, { options: availableDispositions, onChange: function (value) { return setDisposition(value); }, placeholder: "Choose disposition" }), _jsx(TextArea, { onChange: function (e) { return setDispositionNotes(e.target.value); }, value: dispositionNotes, rows: 4, placeholder: "Notes to add to the disposition", "data-test": "dispositionNotes", autoSize: { minRows: 3, maxRows: 6 } }), _jsx(Button, { disabled: !disposition, onClick: function () { return saveDisposition(); }, children: "Save disposition" })] }) })] }));
};
export default DispositionView;
